import ProductPageLayout, { ProductPageConfig } from "@/components/products/ProductPageLayout";
import boiteAccompagnement from "@/assets/products/boite-accompagnement.png";
import boiteAccompagnementFc0 from "@/assets/products/boite-accompagnement-fc0.png";
import boiteAccompagnementFc1 from "@/assets/products/boite-accompagnement-fc1.png";
import boiteAccompagnementLifestyle from "@/assets/products/boite-accompagnement-lifestyle.png";

const config: ProductPageConfig = {
  name: "Boîte accompagnement",
  breadcrumbName: "Boîte accompagnement",
  subtitle: "Boîtes kraft pour accompagnements, snacks et portions",
  features: ["Contact alimentaire", "Recyclable", "Personnalisable", "FSC certifié"],
  variants: [
    { name: "FC0 - Petite", material: "Carton kraft", packaging: "Sur demande", palette: "Sur demande", image: boiteAccompagnementFc0 },
    { name: "FC1 - Grande", material: "Carton kraft", packaging: "Sur demande", palette: "Sur demande", image: boiteAccompagnementFc1 },
  ],
  lifestyleImages: [
    { src: boiteAccompagnementLifestyle, caption: "Idéal pour snacks et accompagnements à emporter" },
  ],
  customization: { maxColors: 4, minOrder: "20 000 pièces", bestPrice: "100 000 pièces" },
};

const BoiteAccompagnement = () => <ProductPageLayout config={config} />;
export default BoiteAccompagnement;
